import { LoadingOverlay } from '@mantine/core'
import { Epg, Layout } from '@nessprim/planby-pro'

import { PopoverBooking } from '@flecto/ui'

import { useSchedulerDataGroupedByItems } from '../../hooks/useSchedulerDataGroupedByItems'
import { ChannelItem } from './ChannelItem'
import { ProgramItem } from './ProgramItem'
import { Timeline } from './Timeline'

export function SchedulerGrouped() {
  const { epg, isLoading } = useSchedulerDataGroupedByItems()

  const { getEpgProps, getLayoutProps } = epg

  return (
    <Epg {...getEpgProps()}>
      <LoadingOverlay visible={isLoading} />
      <Layout
        {...getLayoutProps()}
        renderChannel={({ channel, ...rest }) => (
          <ChannelItem channel={channel} key={channel.index} {...rest} />
        )}
        renderProgram={({ program, ...rest }) => (
          <PopoverBooking
            bookingId={program.data.booking.internal_id}
            key={program.data.id}
            popoverId={program.data.id}
          >
            <ProgramItem program={program} {...rest} />
          </PopoverBooking>
        )}
        renderTimeline={(props) => <Timeline {...props} />}
      />
    </Epg>
  )
}
